
import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, AuthError, composeAuth } from "../../helpers/utils";
import { logoutUser } from "../actions/account";
import querystring from "query-string";

export const getCombinedGoalsAndLocations = createAsyncThunk(
  "combinedSchema/getCombinedGoalsAndLocations",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const query = querystring.stringify({
        tag: payload?.tagId,
        page: payload?.page,
        limit: payload?.limit,
        sortBy: payload?.sortBy,
        sortOrder: payload?.sortOrder
      });

      const url =
        process.env.REACT_APP_SERVER +
        `/combined/institution/${payload?.institutionId}${query ? `?${query}` : ""}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body || {})
      });
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const downloadCombinedGoalsAndLocationsCSV = createAsyncThunk(
  "combinedSchema/downloadCombinedGoalsAndLocationsCSV",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const query = querystring.stringify({
        tag: payload?.tagId,
        sortBy: payload?.sortBy,
        sortOrder: payload?.sortOrder,
      });

      const url =
        process.env.REACT_APP_SERVER +
        `/combined/institution/${payload?.institutionId}/csv-download${query ? `?${query}` : ""}`;

      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body || {}),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
